// Cognito User Pool ID and Client ID are public identifiers — safe to commit.
const awsExports = {
  userPoolId: "ap-south-1_fozyTV1sJ",
  userPoolClientId: "575ka8uqd000t8jq72f617q90h",
  apiUrl: process.env.REACT_APP_API_URL || "https://54v5ypnne2.execute-api.ap-south-1.amazonaws.com/prod",
};
export default awsExports;
